/* These helper functions are used to convert the casing of the keys in the request and response data.
 * We used the same library "humps" and have same helper function names as on subapp-monorepo
 * so it would help later on with the migrating the code over to the subapp-monorepo.
 */

import humps, { HumpsProcessorParameter, Decamelized, Camelized } from 'humps';

export function camelizeResponseData<T>(data: T): Camelized<T> {
  return humps.camelizeKeys(data, convertSnakeCaseKeys);
}

export function decamelizeRequestBody<T>(data: T): Decamelized<T> {
  return humps.decamelizeKeys(data, convertCamelCaseKeys);
}

// pattern to exclude keys that do not have the snake_case format standard
// that is lowcase letters, numbers and underscores
const EXCLUDED_CAMELIZE_KEYS_REGEX = /[^a-z0-9_]+/;

// pattern to exclude keys that do not have the camelCase format standard
// that is the first letter is lowcase and the rest of the words start with uppercase
const EXCLUDED_DECAMELIZE_KEYS_REGEX = /^(?![a-z0-9]+(?:[A-Z][a-z0-9]+)*$).+/;

function convertSnakeCaseKeys(
  key: string,
  convert: HumpsProcessorParameter
): string {
  return EXCLUDED_CAMELIZE_KEYS_REGEX.test(key) ? key : convert(key);
}

function convertCamelCaseKeys(
  key: string,
  convert: HumpsProcessorParameter
): string {
  return EXCLUDED_DECAMELIZE_KEYS_REGEX.test(key) ? key : convert(key);
}
